import ApiClient from '../../../helpers/ApiClient';
import {
  getCampusApiClient,
  getMainAppApiClient,
} from '../../../helpers/getClients';
import { USER_STATUS } from '../../selectors/user';

import type { UserDetails } from './getUserAsPromise';

const defaultProgress = {
  courseProgress: null,
  chapterProgress: null,
  streakInfo: undefined,
};

export default async ({
  authorizationHeader,
  chapterAsPromise,
  courseAsPromise,
  isPreview,
  userAsPromise,
}: {
  authorizationHeader: string | undefined;
  chapterAsPromise: Promise<{ id: number }>;
  courseAsPromise: Promise<{ id: number }>;
  isPreview: boolean;
  userAsPromise: Promise<UserDetails>;
}) => {
  if (isPreview) {
    return defaultProgress;
  }

  const user = await userAsPromise;
  if (user.status === USER_STATUS.UNAUTHORIZED) {
    return defaultProgress;
  }

  const course = await courseAsPromise;
  const chapter = await chapterAsPromise;

  return Promise.all([
    getCampusApiClient()
      .execute(
        ApiClient.endpoint.getCourseProgress({
          courseRef: course.id,
          authorizationHeader,
        }),
      )
      .toPromise(),
    getCampusApiClient()
      .execute(
        ApiClient.endpoint.getChapterProgress({
          authorizationHeader,
          courseRef: course.id,
          chapterRef: chapter.id,
        }),
      )
      .toPromise(),
    getMainAppApiClient()
      .execute(ApiClient.endpoint.getStreak())
      .toPromise()
      .catch(() => {
        // Don't crash the app if the call fails (just hide the XP counter)
        return { body: undefined };
      }),
  ])
    .then(
      ([
        { body: courseProgress },
        { body: chapterProgress },
        { body: streakInfo },
      ]) => ({
        courseProgress,
        chapterProgress,
        streakInfo,
      }),
    )
    .catch(() => defaultProgress);
};
